function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '.*');
}

export function convertWildcardStringToRegExp(expression) {
    var terms = expression.split('*');

    var trailingWildcard = false;

    var expr = '';
    for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
            if (i > 0 && terms[i - 1]) {
                expr += '.*';
            }
            trailingWildcard = false;
            expr += escapeRegExp(terms[i]);
        } else {
            trailingWildcard = true;
            expr += '.*';
        }
    }

    if (!trailingWildcard) {
        expr += '.*';
    }

    return new RegExp('^' + expr + '$', 'i');
}